module.exports = __webpack_public_path__ + "img/plus_d3.85b94f99.png";